import React from 'react';
import { arrayOf, bool, element, func, oneOfType, string } from 'prop-types';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import classnames from 'classnames';

import './CompensationSummaryCard.scss';
import ActionableHeaderCard from 'ps-components/Card/ActionableHeaderCard';

class CompensationSummaryCard extends React.Component {
  static propTypes = {
    cardTitle: string,
    checked: bool,
    children: oneOfType([arrayOf(element), element]),
    onToggle: func,
    isConfigVisible: bool,
    showMarketComparison: bool,
    showZeroWeightMatches: bool,
    saveConfigSettings: func,
    hasData: bool,
    hasEmployeeDataRows: bool
  };

  static defaultProps = {
    hasData: true
  };

  renderMarketComparisonToggle = () => {
    const {
      hasEmployeeDataRows,
      showMarketComparison,
      showMatchDetails,
      showZeroWeightMatches,
      showOverallComposites,
      isRestrictedUser
    } = this.props;

    return (
      <div className="comp-sum-card__header-config-element pxl-text-small">
        <CheckboxInput
          checked={showZeroWeightMatches}
          className="comp-sum-card__header-toggle-checkbox"
          onClick={this.saveZeroWeightMatchesSettings}
          disabled={!showMatchDetails}
        />
        Show Zero Weight Matches
        <CheckboxInput
          checked={showMatchDetails}
          className="comp-sum-card__header-toggle-checkbox"
          onClick={this.saveMatchDetailsSettings}
        />
        Show Match Details
        <CheckboxInput
          checked={showOverallComposites}
          className="comp-sum-card__header-toggle-checkbox"
          onClick={this.saveOverallCompositeSettings}
        />
        Show Overall Composite
        {hasEmployeeDataRows && !isRestrictedUser && (
          <React.Fragment>
            <CheckboxInput
              checked={showMarketComparison}
              className="comp-sum-card__header-toggle-checkbox"
              onClick={this.saveMarketComparisonSettings}
              disabled={!showOverallComposites}
            />
            Show Market Comparison
          </React.Fragment>
        )}
      </div>
    );
  };

  onToggleHandler = id => {
    const { onToggle } = this.props;
    onToggle(id);
  };

  saveZeroWeightMatchesSettings = () => {
    const { showZeroWeightMatches, saveConfigSettings } = this.props;
    saveConfigSettings({ showZeroWeightMatches: !showZeroWeightMatches });
  };

  saveMarketComparisonSettings = () => {
    const { showMarketComparison, saveConfigSettings } = this.props;
    saveConfigSettings({ showMarketComparison: !showMarketComparison });
  };

  saveMatchDetailsSettings = () => {
    const { showMatchDetails, saveConfigSettings } = this.props;
    saveConfigSettings({ showMatchDetails: !showMatchDetails });
  };

  saveOverallCompositeSettings = () => {
    const { showOverallComposites, saveConfigSettings } = this.props;
    saveConfigSettings({ showOverallComposites: !showOverallComposites });
  };

  camelCaseCardName = cardTitle => {
    return cardTitle.charAt(0).toLowerCase() + cardTitle.slice(1);
  };

  render() {
    const { cardTitle, checked, children, hasData, isConfigVisible } = this.props;

    const isAdjustmentOrCommentCard =
      cardTitle === 'Overall Adjustment' ||
      cardTitle === 'Overall Comments' ||
      cardTitle === 'Overall Comments & Adjustment';
    const isParticipationMatchesCard =
      cardTitle === 'Participation Matches With Data' || cardTitle === 'Participation Matches Without Data';
    const isSurveyJobDescriptionCard = cardTitle === 'Survey Job Description';
    const isEmployeeCard = cardTitle === 'Employee Data';

    const lowerCaseSectionName = isAdjustmentOrCommentCard ? 'overallComments' : this.camelCaseCardName(cardTitle);
    const isJobNotPriced = cardTitle === 'Job Not Priced';
    const cardClass = classnames({
      'comp-sum-card': true,
      'comp-sum-card-disabled': !checked || !hasData,
      'comp-sum-card-empty__multiple': (!checked || !hasData) && isJobNotPriced,
      'comp-sum-card-empty__single': !isJobNotPriced && !hasData,
      'page-break-inside__avoid': cardTitle === 'Overall Composites' || isAdjustmentOrCommentCard,
      'extra-margin':
        isParticipationMatchesCard || isSurveyJobDescriptionCard || isEmployeeCard || isAdjustmentOrCommentCard
    });
    const cardHeaderClass = classnames({
      'comp-sum-card__header': true,
      'comp-sum-card__header-disabled': !checked
    });
    const cardContentsClass = classnames({
      'comp-sum-card__contents': true,
      'comp-sum-card__contents-disabled': !checked,
      'comp-sum-card__contents-small': cardTitle === 'Overall Comments' || cardTitle === 'Overall Adjustment'
    });

    return (
      <ActionableHeaderCard
        className={cardClass}
        cardHeaderClassName={cardHeaderClass}
        isToggleChecked={checked}
        cardTitle={cardTitle}
        showHeader={true}
        showTitle={hasData}
        customActionNodes={
          cardTitle === 'Pricing Details' && isConfigVisible && checked ? this.renderMarketComparisonToggle() : null
        }
        isToggleable={isConfigVisible && hasData}
        onToggle={this.onToggleHandler}
        toggleId={lowerCaseSectionName.replace(/\s/g, '')}
        isCollapsible={false}
      >
        <div className={cardContentsClass}>{children}</div>
      </ActionableHeaderCard>
    );
  }
}

export default CompensationSummaryCard;
